import { render } from "./VulnerabilityEvidenceComponent.vue?vue&type=template&id=443bc0c8&scoped=true"
import script from "./VulnerabilityEvidenceComponent.vue?vue&type=script&lang=js"
export * from "./VulnerabilityEvidenceComponent.vue?vue&type=script&lang=js"

import "./VulnerabilityEvidenceComponent.vue?vue&type=style&index=0&id=443bc0c8&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443bc0c8"]])

export default __exports__